var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConciergeAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / concierge_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "223.587167%",
    x2: "25.2064732%",
    y2: "20.3953957%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B33229",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B236",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.8470607%",
    y1: "47.8180178%",
    x2: "88.7131077%",
    y2: "53.8566493%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6C6C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.1393581%",
    y1: "46.4053508%",
    x2: "90.464527%",
    y2: "52.9266389%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.4414063%",
    y1: "12.7220465%",
    x2: "70.1735364%",
    y2: "115.88871%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6C6C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "57.8891727%",
    y1: "-11.4125845%",
    x2: "71.0862072%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.6221994%",
    y1: "91.566132%",
    x2: "36.8860685%",
    y2: "19.6777344%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.867132867,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-concierge_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "concierge",
    transform: "translate(5.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Bubble---Fill",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    points: "38 2.27373675e-13 38 30 50 30 50 41.5 61.5 30 80.0000002 30 80.0000002 2.27373675e-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,1 L79,29 L61.0857864,29 L51,39.0857864 L51,29 L39,29 L39,1 L79,1 Z",
    id: "Bubble---Border",
    stroke: "#E2B236",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,61.325334 C27.872875,61.325334 24.9801875,60.0683617 22.4226875,58 C14.40725,59.0487742 6.84325,61.5413153 0,65.2129978 L0,73 L62,73 L62,65.2129978 C55.15675,61.5413153 47.59275,59.0507199 39.5773125,58 C37.0198125,60.0683617 34.127125,61.325334 31,61.325334 Z",
    id: "Body---Fill",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8663948,59.0478388 C47.3990314,60.0852156 54.5208804,62.4149958 61,65.8144382 L61,65.8144382 L61,72 L1,72 L1,65.8144344 C7.47956672,62.4146644 14.6019566,60.0830686 22.1354831,59.0477443 C24.7958653,61.1048501 27.7866896,62.325334 31,62.325334 C34.2135149,62.325334 37.2045155,61.1046947 39.8663948,59.0478388 Z",
    id: "Body---Border",
    stroke: "url(#linearGradient-3)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,15.5 C33.3066667,15.3266667 32.6438096,15.16 31.9047619,15.0838095 C31.3619048,15.0304762 30.8076191,15 30.2380953,15 C29.6685715,15 29.1142857,15.0304762 28.5714286,15.0838095 C24.2914286,15.5180952 20.7371429,17.6304762 18.3409524,20.9276191 C16.3676191,23.6628572 15.3295238,27.0076191 15.0704762,30.3504762 C15.0247619,30.9371429 15,31.5333334 15,32.1428572 C15,34.352381 15.2533333,36.6209524 15.7142857,38.8457143 C18.0038095,40.0133334 23.0366667,41.75 30.25,41.75 C33.4004762,41.75 36,44.3495238 36,47.5 C36,50.6504762 33.4004762,53 30.25,53 C27.7109524,53 24.8666667,52.8876191 22.0228572,52.4533334 C24.3961905,55.1790477 27.2095238,56.904762 30.2380953,56.904762 C38.1961905,56.904762 44.562381,45.0666667 45.25,34 L34,34 L34,15.5 Z",
    id: "Head---Fill",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2380953,16 C30.7742122,16 31.2959766,16.0288135 31.8022127,16.0785375 C32.214196,16.12101 32.6005806,16.1947243 32.9828303,16.2816599 L32.9828303,16.2816599 L33.0009685,35 L44.1683683,35 C43.6658147,40.2863333 41.8723904,45.6581139 39.2462578,49.6649967 C36.8430426,53.331758 33.7393619,55.904762 30.2380953,55.904762 C28.3075045,55.904762 26.4886262,55.1103236 24.8338534,53.7897749 C26.7146209,53.9498841 28.5495018,54 30.25,54 C32.1136799,54 33.8090764,53.2912534 35.0322819,52.1212307 C36.2453982,50.9608586 37,49.3468538 37,47.5 C37,45.6508074 36.2391594,43.9620887 35.0135354,42.7364646 C33.7879113,41.5108406 32.0991926,40.75 30.25,40.75 C23.6861972,40.75 18.9809097,39.280062 16.5976755,38.1637879 C16.2113974,36.1605235 16,34.1271832 16,32.1428572 C16,31.5597509 16.0237211,30.9894018 16.0674871,30.4277375 C16.3124189,27.2670358 17.2850975,24.1003135 19.1498905,21.5155129 C21.3801975,18.4466247 24.689404,16.482848 28.6692035,16.0790181 C29.1802139,16.0288135 29.7019783,16 30.2380953,16 Z",
    id: "Head---Border",
    stroke: "url(#linearGradient-5)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4761905,7.61904763 C19.0685715,7.61904763 10.3714286,15.3542857 8.17523811,26.6666667 L7.61904763,26.6666667 C5.51428573,26.6666667 3.80952382,28.3714286 3.80952382,30.4761905 L3.80952382,32.3809524 L3.80952382,38.0952382 C3.80952382,40.2000001 5.51428573,41.904762 7.61904763,41.904762 L8.07619049,41.904762 C10.312381,46.6552382 20.7295239,49.5238096 30.4761905,49.5238096 C31.5276191,49.5238096 32.3809524,48.6723811 32.3809524,47.6190476 C32.3809524,46.5657144 31.5276191,45.7142858 30.4761905,45.7142858 C18.8209524,45.7142858 11.4285715,41.6971429 11.4285715,40.0000001 L11.4285715,32.3809524 C11.4285715,20.24 19.44,11.4285715 30.4761905,11.4285715 C31.792381,11.4285715 33.0628572,11.5619048 34.2857144,11.8038095 L34.2857144,7.94666668 C33.0514286,7.74857144 31.7866667,7.61904763 30.4761905,7.61904763 Z",
    id: "Set---Fill",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConciergeAppTile);
export default __webpack_public_path__ + "static/media/concierge_app_tile.c4077c0d688d8e05e478ff75032296ea.svg";
export { ForwardRef as ReactComponent };